// extracted by mini-css-extract-plugin
module.exports = {"label":"bL_6","mobileOnly":"bL_hJ","content":"bL_m","toggle":"bL_hK","darkMode":"bL_cN"};